import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import ProductCard from '../../components/ProductCard'
import Loader from '../../components/Loader'
import { FaTimes } from 'react-icons/fa'

const Shelf = () => {
    const [products, setProducts] = useState([])
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const [isLoading, setIsLoading] = useState(false)


    const { name, shelf } = useParams()
    const limit = 20

    const fetchProducts = async () => {
        try {
            setIsLoading(true)
            const response = await api.get(`/stores/${name}/shelves/${shelf}?page=${page}&limit=${limit}`)
            setIsLoading(false)

            // If it's the first page, set products
            if (page === 1) {
                setProducts(response.data.products)
            } else {
                setProducts((prev) => [...prev, ...response.data.products])
            }

            setHasMore(response.data.products.length === limit)
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong")
            setHasMore(false)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchProducts()
    }, [page])

    return (
        <div>
            <h2 className="page-header-title">{shelf}</h2>
            <div className="shelf-products-wrapper">
                <InfiniteScroll
                    dataLength={products.length}
                    next={() => setPage((prev) => prev + 1)}
                    hasMore={hasMore}
                    loader={<Loader />}
                >
                    <div className="store-shelf-products">
                        {
                            products.length ? products.map((p) => (
                                <ProductCard key={p._id} product={p} />
                            )) : isLoading ? null : <p>No products found in this shelf</p>
                        }
                    </div>
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default Shelf